import factoryLogger from '../../logger/index.js'
import I18nRepositoriesFactory from '../Repositories/factory.js'
import GetLiteralsI18nUseCase from '../UseCases/GetLiteralsI18nUseCase.js'

export default class I18nUseCasesFactory {
  static getLiteralsI18nUseCase = ({config}) =>
    new GetLiteralsI18nUseCase({
      repository: I18nRepositoriesFactory.hTTPI18nRepository({config}),
      log: factoryLogger({prefix: 'GetLiteralsI18nUseCase'})
    })
}
